var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#design_svg__clip0)",
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.25 22.5H3.75A3.755 3.755 0 010 18.75v-15A3.755 3.755 0 013.75 0h52.5A3.755 3.755 0 0160 3.75v15a3.755 3.755 0 01-3.75 3.75zm-52.5-20c-.688 0-1.25.56-1.25 1.25v15c0 .69.563 1.25 1.25 1.25h52.5c.688 0 1.25-.56 1.25-1.25v-15c0-.69-.563-1.25-1.25-1.25H3.75zM56.25 45h-20a3.755 3.755 0 01-3.75-3.75v-10a3.755 3.755 0 013.75-3.75h20A3.755 3.755 0 0160 31.25v10A3.755 3.755 0 0156.25 45zm-20-15c-.688 0-1.25.56-1.25 1.25v10c0 .69.563 1.25 1.25 1.25h20c.688 0 1.25-.56 1.25-1.25v-10c0-.69-.563-1.25-1.25-1.25h-20zM26.25 30h-25a1.25 1.25 0 010-2.5h25a1.25 1.25 0 010 2.5zM26.25 37.5h-25a1.25 1.25 0 010-2.5h25a1.25 1.25 0 010 2.5zM26.25 45h-25a1.25 1.25 0 010-2.5h25a1.25 1.25 0 010 2.5zM58.75 52.5H1.25a1.25 1.25 0 010-2.5h57.5a1.25 1.25 0 010 2.5zM58.75 60H1.25a1.25 1.25 0 010-2.5h57.5a1.25 1.25 0 010 2.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "design_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}

export default SvgDesign;